<template>
  <el-dialog
      :model-value="props.visible"
      title="提示信息"
      width="600"
      top="6vh"
      destroy-on-close
      :close-on-click-modal="false"
      @open="onOpen"
      @closed="closedModal"
  >
    <div v-loading="pageLoading">
      <div style="padding-top: 20px;">
        <el-form :model="formData" ref="formRef"
                 size="large"
                 :rules="rules" :inline="true" label-width="130px">
          <el-form-item label="请输入证书密码:" prop="password">
            <el-input
                v-model="formData.password"
                placeholder="请输入"
                style="width: 300px"
                maxlength="30"
                clearable
                type="password"
            >
              <template #prefix>
                <img
                    src="https://static.rhkj.com/renhe_fe/other/311.gif"
                />
              </template>
            </el-input>
          </el-form-item>
        </el-form>
      </div>

      <div class="my-footer">
        <el-button @click="emit('update:visible', false)">取消</el-button>
        <el-button type="primary" style="margin-right: 15px;" @click="onConfirm">确定</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script setup>
const props = defineProps({
  visible: {
    type: Boolean,
    required: true
  },
})

const pageLoading = ref(false)
const formData = ref({})
const rules = reactive({
  password: [
    {required: true, message: '请输入', trigger: 'blur'},
  ],
})

function onOpen() {
}

const formRef = ref()

const emit = defineEmits(['update:visible', 'confirm'])

async function onConfirm() {
  await formRef.value.validate(valid => {
    if (valid) {
      emit('confirm', formData.value.password)
      emit('update:visible', false)
    }
  })
}

function closedModal() {
  emit('update:visible', false)
  formData.value = {}
}
</script>

<style scoped lang="scss">
.my-footer {
  display: flex;
  flex-direction: row-reverse;
  margin-top: 30px;
}
</style>
